@if (folderId) {
    <app-card-table
        #personWorkplaceTable
        tableKey="personWorkplaces"
        [gridData]="$any(store.folderWorkplaces$ | async)"
        translatePrefix="workplace."
        [columns]="columns"
        [tableTitle]="'workplace.label'"
        [hideCheckboxes]="true"
        (createCallback)="editWorkplace()"
        (detailCallback)="editWorkplace($event)"
        (deleteCallbackWithEvent)="deleteWorkplace($event)"
        [refreshCallback]="store.api.getFolderWorkplaces"
        [additionalFilter]="additionalFilter"
        [showDetail]="canEdit()"
        [showDelete]="canEdit()"
        [showCreate]="canEdit()"
    >
    </app-card-table>
}

<app-edit-workplace-modal></app-edit-workplace-modal>
